import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // 1. Import the hook
import Image1 from "../../assets/sms2.webp";

const Otp = () => {
  const navigate = useNavigate(); // 2. Initialize navigate

  // State to handle which FAQ is open
  const [openFaq, setOpenFaq] = useState(null);

  // FAQ Data specifically for OTP services
  const faqs = [
    {
      question: "What is an SMS OTP service?",
      answer: "An SMS OTP (One-Time Password) service is a security measure that sends a unique, time-sensitive code to a user's mobile phone via SMS to verify their identity during login or transactions."
    },
    {
      question: "How fast is the OTP delivery?",
      answer: "Our infrastructure is optimized for speed, with an average delivery time of 2.8 seconds globally, ensuring your users aren't kept waiting during critical login moments."
    },
   
    {
      question: "What happens if a message fails to deliver?",
      answer: "We use smart routing and fallback carrier paths. If a primary route faces congestion, our system automatically re-routes the OTP through the next best available path."
    },
  
    {
      question: "Can OTP messages be localized in different languages?",
      answer: "Yes. OTP templates can be created in multiple languages and mapped per region or user preference."
    }
  ];

  return (
    <div className="bg-[#EEF2FC]">
      {/* ================= FIRST SECTION — HERO ================= */}
      <section className="relative w-full min-h-[80vh] flex items-start bg-[#EEF2FC] overflow-hidden pt-12 pb-20 px-6">
        <div className="max-w-[1400px] mx-auto lg:ml-20 grid grid-cols-1 lg:grid-cols-2 gap-12 items-start relative z-10 mt-8">

          {/* Left Content */}
          <div className="space-y-8 text-center lg:text-left">
            <h1 className="text-3xl md:text-5xl font-medium text-slate-900 leading-tight">
              Protect user logins
              <br className="hidden md:block" /> worldwide with Eurofox's
              <br className="hidden md:block" />
              SMS OTP service
            </h1>

            <p className="text-lg md:text-xl text-slate-700 max-w-lg mx-auto lg:mx-0 leading-relaxed">
              With Eurofox's SMS OTP service, businesses can verify users quickly and securely through a robust global messaging infrastructure. Designed for high deliverability and speed, the platform supports secure authentication at scale while reaching users across international telecom networks.
            </p>

            <div className="flex flex-wrap justify-center lg:justify-start gap-4 pt-4">
              <button
                onClick={() => navigate('/contact')}
                className="px-6 py-3 bg-slate-900 text-white font-medium rounded-lg transition-all hover:bg-slate-900"
              >
                Contact an expert →
              </button>
            </div>
          </div>

          {/* Right Content */}
          <div className="flex justify-center lg:justify-end">
            <div className="w-full max-w-[600px] max-h-[500px] overflow-hidden">
              <img
                src={Image1}
                alt="Eurofox SMS OTP Dashboard"
                className="w-full h-full object-contain object-top block"
              />
            </div>
          </div>
        </div>
      </section>

      {/* ================= SECOND SECTION — OTP DETAILS ================= */}
      <section className="w-full bg-[#EEF2FC] py-20 px-6">
        <div className="max-w-[1300px] mx-auto">

          {/* Heading */}
          <div className="text-center max-w-3xl mx-auto mb-16 lg:-mt-24 relative z-20">
            <h2 className="text-3xl md:text-5xl font-medium text-slate-900 mb-6">
              Reliable OTP Delivery Built for Speed & Security
            </h2>
            <p className="text-lg text-slate-600 leading-relaxed">
              Our SMS OTP platform is engineered for mission-critical authentication.
              From instant code delivery to global network reach, every message is optimized
              for performance, reliability, and user trust.
            </p>
          </div>

          {/* Feature Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
            {/* Card 1 */}
            <div className="bg-[#D0DCF2] hover:bg-white p-8 rounded-2xl border border-slate-200 hover:shadow-lg transition">
              <h3 className="text-xl font-semibold text-slate-900 mb-3">
                Instant Code Delivery
              </h3>
              <p className="text-slate-800 leading-relaxed">
                Lightning-fast OTP routing ensures users receive verification codes
                within seconds, reducing login friction and improving conversion rates.
              </p>
            </div>

            {/* Card 2 */}
            <div className="bg-[#D0DCF2] hover:bg-white p-8 rounded-2xl border border-slate-200 hover:shadow-lg transition">
              <h3 className="text-xl font-semibold text-slate-900 mb-3">
                Global Network Coverage
              </h3>
              <p className="text-slate-800 leading-relaxed">
                Deliver OTP messages worldwide through high-quality carrier routes
                with strong redundancy and optimized regional delivery paths.
              </p>
            </div>

            {/* Card 3 */}
            <div className="bg-[#D0DCF2] hover:bg-white p-8 rounded-2xl border border-slate-200 hover:shadow-lg transition">
              <h3 className="text-xl font-semibold text-slate-900 mb-3">
                Enterprise-Grade Security
              </h3>
              <p className="text-slate-800 leading-relaxed">
                Protect user access with secure authentication flows designed
                to support banking, fintech, SaaS, and high-risk login environments.
              </p>
            </div>

            {/* Card 4 */}
            <div className="bg-[#D0DCF2] hover:bg-white p-8 rounded-2xl border border-slate-200 hover:shadow-lg transition">
              <h3 className="text-xl font-semibold text-slate-900 mb-3">
                High Deliverability
              </h3>
              <p className="text-slate-800 leading-relaxed">
                Smart routing and operator partnerships maximize OTP delivery success
                while minimizing latency and message failures.
              </p>
            </div>

            {/* Card 5 */}
            <div className="bg-[#D0DCF2] hover:bg-white p-8 rounded-2xl border border-slate-200 hover:shadow-lg transition">
              <h3 className="text-xl font-semibold text-slate-900 mb-3">
                Scalable API Integration
              </h3>
              <p className="text-slate-800 leading-relaxed">
                Simple developer APIs allow quick OTP integration into apps,
                websites, and platforms with support for high request volumes.
              </p>
            </div>

            {/* Card 6 */}
            <div className="bg-[#D0DCF2] hover:bg-white p-8 rounded-2xl border border-slate-200 hover:shadow-lg transition">
              <h3 className="text-xl font-semibold text-slate-900 mb-3">
                Real-Time Monitoring
              </h3>
              <p className="text-slate-800 leading-relaxed">
                Track OTP performance with real-time reporting and delivery insights
                to maintain authentication reliability at scale.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Use Cases Section - 3RD SECTION MODIFIED FOR MOBILE */}
      <section className="w-full py-16 px-6 bg-[#EEF2FC]">
        <div className="max-w-[1400px] mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">

            {/* Content Column */}
            <div className="order-1 -mt-10 lg:mt-0">
              <h2 className="text-3xl md:text-5xl font-medium text-slate-900 mb-6 text-center lg:text-left">
                Secure Authentication for Every Use Case
              </h2>
              <p className="text-lg text-slate-700 mb-8 leading-relaxed text-center lg:text-left">
                From financial transactions to healthcare systems, our OTP service provides reliable two-factor authentication across industries.
              </p>

              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 bg-slate-900 text-white rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                    ✓
                  </div>
                  <div>
                    <h4 className="text-xl font-medium text-slate-900 mb-2">Financial Services</h4>
                    <p className="text-slate-700">Secure online banking, payment confirmations, and fraud prevention for financial institutions.</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 bg-slate-900 text-white rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                    ✓
                  </div>
                  <div>
                    <h4 className="text-xl font-medium text-slate-900 mb-2">E-commerce & Retail</h4>
                    <p className="text-slate-700">Protect customer accounts, verify transactions, and prevent unauthorized access.</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 bg-slate-900 text-white rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                    ✓
                  </div>
                  <div>
                    <h4 className="text-xl font-medium text-slate-900 mb-2">Healthcare</h4>
                    <p className="text-slate-700">Secure patient portal access and protect sensitive medical records with HIPAA-compliant OTP.</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 bg-slate-900 text-white rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                    ✓
                  </div>
                  <div>
                    <h4 className="text-xl font-medium text-slate-900 mb-2">Enterprise Security</h4>
                    <p className="text-slate-700">Employee login verification, remote access authentication, and privileged account protection.</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Tech Spec Box */}
            <div className="bg-[#D0DCF2] p-8 rounded-2xl order-2">
              <h3 className="text-2xl font-medium text-slate-900 mb-6">Technical Specifications</h3>

              <div className="space-y-6">
                <div>
                  <div className="flex justify-between items-center mb-2">
                    <span className="text-slate-800 font-medium">Delivery Success Rate</span>
                    <span className="text-slate-900 font-bold">99.95%</span>
                  </div>
                  <div className="w-full bg-slate-100 rounded-full h-2">
                    <div className="bg-green-500 h-2 rounded-full" style={{ width: '99.95%' }}></div>
                  </div>
                </div>

                <div>
                  <div className="flex justify-between items-center mb-2">
                    <span className="text-slate-800 font-medium">Average Delivery Time</span>
                    <span className="text-slate-900 font-bold">2.8s</span>
                  </div>
                  <div className="w-full bg-slate-100 rounded-full h-2">
                    <div className="bg-blue-500 h-2 rounded-full" style={{ width: '93%' }}></div>
                  </div>
                </div>

                <div>
                  <div className="flex justify-between items-center mb-2">
                    <span className="text-slate-800 font-medium">Global Reach</span>
                    <span className="text-slate-900 font-bold">190+ Countries</span>
                  </div>
                  <div className="w-full bg-slate-100 rounded-full h-2">
                    <div className="bg-purple-500 h-2 rounded-full" style={{ width: '100%' }}></div>
                  </div>
                </div>

                <div className="pt-4 border-t border-slate-100">
                  <h4 className="text-lg font-medium text-slate-900 mb-4">Supported Integrations</h4>
                  <div className="grid grid-cols-2 lg:flex lg:flex-wrap gap-3">
                    <span className="px-4 py-2 bg-blue-50 text-blue-700 rounded-lg font-medium text-center text-sm md:text-base">REST API</span>
                    <span className="px-4 py-2 bg-green-50 text-green-700 rounded-lg font-medium text-center text-sm md:text-base">SMTP</span>
                    <span className="px-4 py-2 bg-purple-50 text-purple-700 rounded-lg font-medium text-center text-sm md:text-base">Webhooks</span>
                    <span className="px-4 py-2 bg-amber-50 text-amber-700 rounded-lg font-medium text-center text-sm md:text-base">SDKs</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ================= FOURTH SECTION — FAQ ================= */}
      {/* SHIFTED UP: Added -mt-12 and removed border-t */}
      <section className="bg-[#EEF2FC] w-full py-16 md:py-24 px-6 md:px-12 lg:px-20 -mt-12">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-start justify-between gap-12">

          {/* Left Side: Heading with Animated Underline */}
          <div className="w-full lg:w-1/3">
            <div className="relative inline-block group">
              <h2 className="text-4xl md:text-5xl font-medium text-slate-900 leading-tight">
                Frequently <br className="hidden lg:block" /> asked questions
              </h2>
              {/* ANIMATED UNDERLINE */}
              <span className="absolute left-0 bottom-0 w-1/4 h-1 bg-[#F46653] rounded-full transition-all duration-500 group-hover:w-full"></span>
            </div>
          </div>

          {/* Right Side: Professional Accordion Questions */}
          <div className="w-full lg:w-2/3 space-y-3">
            {faqs.map((faq, index) => (
              <div key={index} className="bg-white rounded-2xl overflow-hidden transition-all duration-300 shadow-sm border border-slate-100 hover:border-slate-300">
                <button
                  onClick={() => setOpenFaq(openFaq === index ? null : index)}
                  className="w-full flex items-center justify-between p-5 md:p-6 text-left hover:bg-slate-50 transition-colors"
                >
                  <span className="text-base md:text-lg font-medium text-slate-800 leading-snug">
                    {faq.question}
                  </span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={2}
                    stroke="currentColor"
                    className={`w-5 h-5 text-slate-500 transition-transform duration-300 ${openFaq === index ? 'rotate-180' : ''}`}
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                  </svg>
                </button>

                <div
                  className={`overflow-hidden transition-all duration-300 ease-in-out ${openFaq === index ? 'max-h-[300px] opacity-100' : 'max-h-0 opacity-0'
                    }`}
                >
                  <div className="p-6 pt-0 text-slate-600 leading-relaxed border-t border-slate-50">
                    {faq.answer}
                  </div>
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>
    </div>
  );
};

export default Otp;